<template>
  
  <v-container fluid grid-list-xl class="pt-0 mb-5">

    <v-layout>
      <v-flex>
        
        <transition name="fade-up" mode="out-in" appear>
          <v-container v-if="loading" key="step_loading">
            <v-layout row>
              <v-flex>
                <div class="spinner">
                  <div class="double-bounce1"></div>
                  <div class="double-bounce2"></div>
                </div>
              </v-flex>
            </v-layout>
          </v-container>
          <v-container fluid grid-list-xl v-else-if="this.step == 'activities'" class="trip-wizard" key="step_activities">
            <v-layout column>

              <v-flex class="pb-0">
                <v-layout row>
                  <v-flex xs12 class="text-xs-center">
                    <h1>The purpose of my travel includes...</h1>
                  </v-flex>
                </v-layout>
                <v-layout row justify-center align-center my-0>
                  <v-flex shrink style="min-height: 50px;" class="pt-2 pb-0">
                    <span class="">*Select all that apply</span>
                  </v-flex>
                </v-layout>
              </v-flex>

              <v-flex my-1>
                <v-layout row wrap justify-center class="ma-0 pa-0">
                  <v-flex
                    v-for="(activity, activityIndex) in options.occasion_types"
                    :key="'activity-' + activity.key"
                    :data-index="activityIndex"
                    xs6
                    sm4
                    md3
                    lg2
                    class="box-container pa-1"
                  >
                    <v-hover>
                      <div 
                        slot-scope="{ hover }"
                        class="box-subcontainer pa-2"
                        :class="{'hovering':hover, 'selected':(selections.occasion_type.indexOf(activity.key) >= 0)}"
                        @click="toggleValue('occasion_type', activity.key)"
                      >
                        <div 
                          class="img-container" 
                          :style="{backgroundImage: 'url(' + cdn + activity.image + ')'}"
                        >
                        </div>
                        <div class="label-container font-weight-bold py-2">{{ activity.label }}</div>
                      </div> 
                    </v-hover>
                  </v-flex>
                </v-layout>
              </v-flex>

            </v-layout>

          </v-container>


          <v-container fluid grid-list-xl v-else-if="this.step == 'location'" class="trip-wizard" key="step_location">
            <v-layout column>

              <v-flex class="pb-0">
                <v-layout row>
                  <v-flex xs12 class="text-xs-center">
                    <h1>My travel accommodations include...</h1>
                  </v-flex>
                </v-layout>
                <v-layout row justify-center align-center my-0>
                  <v-flex shrink style="min-height: 50px;" class="pt-2 pb-0">
                    <span>*Currently we only ship in th US.</span>
                  </v-flex>
                </v-layout>
              </v-flex>

              <v-flex my-1>
                <v-layout row wrap justify-center>
                  <v-flex
                    v-for="(location, locationIndex) in options.location_types"
                    :key="'location-' + location.key"
                    :data-index="locationIndex"
                    xs6
                    sm4
                    md3
                    lg2
                    class="box-container"
                    :class="{'location-ship': (location.key == 'ship')}"
                  >
                    <v-hover>
                      <div 
                        slot-scope="{ hover }"
                        class="box-subcontainer pa-2"
                        :class="{'hovering':hover, 'selected':(selections.location_type ==  location.key)}"
                        @click="selections.location_type = location.key"
                      >
                        <div 
                          class="img-container"
                          :style="{backgroundImage: 'url(' + cdn + location.image + ')'}"
                        ></div>
                        <div class="label-container font-weight-bold py-2">{{ location.label }}</div>
                        <div class="label-container" v-if="location.key == 'ship'"><i>I'd prefer to pack the pieces myself</i></div>
                      </div>
                    </v-hover>
                    
                  </v-flex>
                </v-layout>
              </v-flex>

            </v-layout>

          </v-container>


          <v-container fluid grid-list-xs v-else-if="this.step == 'location_details'" class="trip-wizard" key="step_location_details">
            
            <v-layout column v-if="selections.location_type == 'hotel'">

              <v-flex class="pb-0">
                <v-layout row>
                  <v-flex xs12 class="text-xs-center">
                    <h1>The location of my hotel is...</h1>
                  </v-flex>
                </v-layout>
                <v-layout row justify-center align-center my-0>
                  <v-flex shrink style="min-height: 50px;" class="pt-2 pb-0">
                    <span>*Currently we only ship in th US.</span>
                  </v-flex>
                </v-layout>
              </v-flex>

              
        

              <v-flex my-1>
                <v-layout row align-center>
                  <v-flex xs12 md6 lg4 offset-md3 offset-lg4>
                    <address-container 
                      :prefill="selections.address" 
                      hotel-field
                      @on-update="updateSelectedAddress"
                      :nameField="{label:'Reservation Name',placeholder:'Ex: Name the reservation is booked under'}"
                    ></address-container>
                  </v-flex>
                </v-layout>
              </v-flex>

            </v-layout>


            <v-layout column v-if="selections.location_type == 'airbnb'">

              <v-flex class="pb-0">
                <v-layout row>
                  <v-flex xs12 class="text-xs-center">
                    <h1>The location of my Airbnb rental is...</h1>
                  </v-flex>
                </v-layout>
                <v-layout row justify-center align-center my-0>
                  <v-flex shrink style="min-height: 50px;" class="pt-2 pb-0">
                    <span>*Currently we only ship in th US.</span>
                  </v-flex>
                </v-layout>
              </v-flex>

              
              <v-flex my-1>
                <v-layout row justify-center wrap>
                  <v-flex xs12 md5 lg4 offset-md1>
                    <address-container
                      :prefill="selections.address" 
                      @on-update="updateSelectedAddress"
                      :nameField="{label:'Reservation Name',placeholder:'Ex: Name the reservation is booked under'}"
                      host-field
                    ></address-container>
                  </v-flex>

                  <v-flex 
                    md1
                    class="text-align: center;"
                    v-if="$vuetify.breakpoint.mdAndUp"
                  >
                    <div style="border-left: 2px solid #999; height: 100%; margin-left: 50%; width: 1px;"></div>
                  </v-flex>
                  
                  <v-flex xs12 md5 lg4>
                    <div class="font-weight-bold">*If you are an Airbnb guest here are some tips to enjoy the best TRVL Porter experience</div>
                    <div class="mt-3"><strong>Tip 1:</strong> Please contact your host to confirm the package will have no problem arriving and will be kept in a location you can receive</div>
                    <div class="mt-3"><strong>Tip 2:</strong> Locate a USPS location near to your Airbnb where you can return the prepaid package at the end of your trip</div>
                  </v-flex>
                </v-layout>
              </v-flex>

            </v-layout>



            <v-layout column v-if="selections.location_type == 'ship'">

              <v-flex class="pb-0">
                <v-layout row>
                  <v-flex xs12 class="text-xs-center">
                    <h1>Ship to my home address before I go...</h1>
                  </v-flex>
                </v-layout>
                <v-layout row justify-center align-center my-0>
                  <v-flex shrink style="min-height: 50px;" class="pt-2 pb-0">
                    <span>*Please allow at least 3 business days prior to travel to guarantee  your package arrives on time.</span>
                  </v-flex>
                </v-layout>
              </v-flex>

              
        

              <v-flex my-1>
                <v-layout row align-center>
                  <v-flex xs12 md6 lg4 offset-md3 offset-lg4>
                    <address-container 
                      :prefill="selections.address" 
                      @on-update="updateSelectedAddress"
                      check-in-field="Trip Start"
                      check-out-field="Trip End"
                      travel-location
                    ></address-container>
                  </v-flex>
                </v-layout>
              </v-flex>

            </v-layout>

          </v-container>
        


          <style-wizard
            v-else-if="this.step == 'style'"
            key="step_style"
            ref="styleWizard"
            :reverse="directionReverse"
            @on-update="updateSelectedStyle"
            @on-cancel="stylingCancelled"
            @on-complete="stylingComplete"
          >
          </style-wizard>
        
          <fit-wizard
            v-else-if="this.step == 'size'"
            key="step_size"
            ref="fitWizard"
            :prefill="selections.size"
            :reverse="directionReverse"
            @on-update="updateSelectedSize"
            @on-cancel="sizingCancelled"
            @on-complete="sizingComplete"
          ></fit-wizard>

          <lookbook
            v-else-if="this.step == 'lookbook'"
            key="step_lookbook"
            ref="lookbook"
            :prefill="selections.lookbook"
            :request-more="(!selections.order || selections.order.status == 'PENDING')"
            :order="selections.order"
            :order-expansion="orderExpansion"
            @on-order-updated="lookbookOrderUpdated"
            @on-update="updateLookbook"
            @on-complete="lookbookComplete"
            @on-cancel="lookbookCancelled"
            @on-new-trip="checkRoute()"
          ></lookbook>

          <checkout
            v-else-if="this.step == 'checkout'"
            key="step_checkout"
            ref="checkout"
            :selections="selections"
            @on-update="updateOrder"
            @on-cancel="checkoutCancelled"
            @reload="getDataFromApi()"
          ></checkout>

        </transition>

      </v-flex>
    </v-layout>

  </v-container>

</template>

<script>
import Style from './wizard/Style';
import Fit from './wizard/Fit';
import AddressContainer from './wizard/AddressContainer';
import Lookbook from './wizard/Lookbook';
import Checkout from './wizard/Checkout';

import InventoryItem from '@/components/helpers/InventoryItem';

import tripOptions from '@/consts/tripOptions';

export default {
  name: 'Wizard',
  components: {
    'style-wizard': Style,
    'fit-wizard': Fit,
    'address-container': AddressContainer,
    'lookbook': Lookbook,
    'checkout': Checkout,
    'inventory-item': InventoryItem
  },
  data () {
    return {
      loading: true,

      step: null,

      selections: {
        id: null,
        occasion_type: [],
        location_type: null,
        address: {},

        style: {},
        size: {},
        lookbook: {},
        order: {}
      },

      options: tripOptions, 


      checkinDialog: false,
      checkoutDialog: false,

      directionReverse: false,

      tripExpansion: 'lookbook,lookbook.inventory,lookbook.inventory.variations,lookbook.lookbookInventory,lookbook.inventory.materials,lookbook.inventory.variations.colors,order,order.orderInventory,order.orderInventory.itemReview,order.inventory,order.inventory.variations,occasions,order.coupon,tripReview',
      orderExpansion: 'orderInventory,orderInventory.itemReview,inventory,inventory.variations,coupon'
    }
  },
  mounted: function() {
    this.checkRoute();
  },
  watch: {
    '$route': function(to, from) {
      if(to.params.id != from.params.id) {
        this.checkRoute();
      }
    },
    'selections': {
      handler: function(newVal, oldVal) {
        this.toggleWizardNextPrev();
      },
      deep: true
    },
    'step': function(newVal, oldVal) {
      this.toggleWizardNextPrev();
    }
  },
  beforeDestroy: function() {
    this.$store.dispatch('wizardHide');
  },
  computed: {
    cdn: function() {
      return this.$root.cdn;
    },
    user: function() {
      return this.$store.getters.user;
    },
    styleFirst: function() {
      return this.$store.getters.wizardNavigator.styleFirst;
    },
    showSizeAndStyle: function() {
      return this.$store.getters.wizardNavigator.showSizeAndStyle;
    },
    /*options: function() {
      return {
        occasion_type: [
          {
            key: 'business_meeting',
            label: 'Business Meeting',
            image: this.cdn + 'purpose_meeting.png'
          },
          {
            key: 'cocktail_party',
            label: 'Cocktail Party',
            image: this.cdn + 'purpose_cocktail.png',
          },
          {
            key: 'wedding',
            label: 'Wedding',
            image: this.cdn + 'purpose_wedding.png'
          },
          {
            key: 'beach',
            label: 'Beach',
            image: this.cdn + 'purpose_beach.png'
          },
          {
            key: 'conference',
            label: 'Conference',
            image: this.cdn + 'purpose_conference.png'
          },
          {
            key: 'sightseeing',
            label: 'Sightseeing',
            image: this.cdn + 'purpose_sight.png'
          }
        ],
        location_types: [
          {
            key: 'hotel',
            label: 'Hotel',
            image: this.cdn + 'location_hotel.png',
          },
          {
            key: 'airbnb',
            label: 'Airbnb',
            image: this.cdn + 'location_air.png',
          },
          {
            key: 'ship',
            label: 'Ship to my home!',
            image: this.cdn + 'location_ship.png',
          }
        ],
      }
    },*/
    wizard: function() {
      let wizard = [
        'activities',
        'location',
        'location_details'
      ];
      if(this.showSizeAndStyle) {

        if(this.styleFirst) {
          wizard.unshift('size');
          wizard.unshift('style');
        } else {
          wizard.push('style');
          wizard.push('size');
        }
      }
      wizard.push('lookbook');
      wizard.push('checkout');

      return wizard;
    },
    nextDisabled: function() {
      if(this.step == 'activities' && this.selections.occasion_type.length == 0) return true;
      if(this.step == 'location' && !this.selections.location_type) return true;
      if(this.step == 'location_details') {
        if( !this.selections.address.name ||
            !this.selections.address.street_address ||
            !this.selections.address.city ||
            !this.selections.address.state ||
            !this.selections.address.zip ||
            !this.selections.address.date_start ||
            !this.selections.address.date_end
        ) {
          return true;
        }
        if(this.selections.location_type == 'hotel' && !this.selections.address.hotel) return true;
        if(this.selections.location_type == 'ship' && (
          !this.selections.address.travel_city ||
          !this.selections.address.travel_state ||
          !this.selections.address.travel_country 
        )) return true;
      }
      return false;
    },
    previousDisabled: function() {
      if(!this.styleFirst && this.wizard.indexOf(this.step) <= 0) return true;
      if(this.styleFirst && this.wizard.indexOf(this.step) == 0 && this.step == 'activities') return true;
      return false;
    },
    statesFormatted: function() {
      let states = [];
      for(let i = 0; i < Object.keys(this.options.states).length; i++) {
        let key = Object.keys(this.options.states)[i];
        let state = this.options.states[ key ];
        states.push({text:state,value:key});
      }
      return states;
    }
  },
  methods: {
    checkRoute: function() {
      this.loading = true;

      if(this.$store.getters.hasStyle && this.$store.getters.hasFit) {
        this.$store.commit('hideWizardSizeStyle');
        this.step = 'activities';
      } else {
        this.$store.commit('showWizardSizeStyle');
        this.step = (this.styleFirst && this.showSizeAndStyle ? 'style' : 'activities');
      }

      this.$store.dispatch('wizardDisablePrev');
      this.$store.dispatch('wizardDisableNext');
      this.$store.commit('setWizardProgressStep', (this.styleFirst && this.showSizeAndStyle ? 'style' : 'trip'));
      this.$store.dispatch('wizardShow');

      if(this.$route.params.id == 'new') {
        this.selections = {
          id: null,
          occasion_type: [],
          location_type: null,
          address: {},

          style: {},
          size: {},
          lookbook: {}
        };
        this.loading = false;
      } else {
        this.getDataFromApi();
      }
    },
    getDataFromApi: function() {
      this.$http.get('trips/' + this.$route.params.id + '?expand=' + this.tripExpansion)
        .then(response => {
          if(response.data.user_id != this.user.id) {
            this.$router.replace({name: 'account-trips'});
            return;
          }

          this.updateSelections(response.data);

          if(response.data.lookbook.status == 'PREPARING') {
            this.step = 'activities';
            this.loading = false;
          } else {
            let selected = 0;
            for(let i = 0; i < response.data.lookbook.lookbookInventory.length; i++) {
              if(response.data.lookbook.lookbookInventory[i].variation_sel_id) {
                let inv_id = response.data.lookbook.lookbookInventory[i].inventory_id;
                let var_id = response.data.lookbook.lookbookInventory[i].variation_sel_id;
                for(let i2 = 0; i2 < response.data.lookbook.inventory.length; i2++) {
                  let lbinv = response.data.lookbook.inventory[i2];
                  if(lbinv.id == inv_id) {
                    for(let i3 = 0; i3 < lbinv.variations.length; i3++) {
                      let lbvar = lbinv.variations[i3];
                      if(lbvar.id == var_id) {
                        if(lbvar.available && lbvar.stock_quantity > 0) selected++;
                        break;
                      }
                    }
                    break;
                  }
                }
              }
            }
            if(response.data.order && response.data.order.status != null && response.data.order.status != 'PENDING') {
              this.step = 'checkout';
            } else if(selected >= 2) {
              this.step = 'checkout';
            } else {
              this.step = 'lookbook';
            }
            this.loading = false;
          }
          /*if(!response.data.lookbook_id) {
            this.step = 'activities';
            this.loading = false;
          } else {
            this.$http.get('lookbooks/' + response.data.lookbook_id + '/inventory')
              .then(lookbookResponse => {
                this.$set(this.selections, 'lookbook', lookbookResponse.data[0]);

                if(!lookbookResponse.data[0].order_id) {
                  if(lookbookResponse.data[0].user_selected && lookbookResponse.data[0].user_selected.length > 1) {
                    this.step = 'checkout';
                  } else {
                    this.step = 'lookbook';
                  }
                  this.loading = false;
                } else {
                  this.$http.get('orders/' + lookbookResponse.data[0].order_id)
                    .then(orderResponse => {
                      this.$set(this.selections, 'order', orderResponse.data);
                      this.step = 'checkout';
                      this.loading = false;
                    })
                    .catch(orderError => {
                      this.$swal.fire("There was a problem", "There was an issue retrieving your order information");
                    })
                }
              })
              .catch(lookbookError => {
                this.$swal.fire("There was a problem","There was an issue retrieving your lookbook");
              })
          }*/
          
        })
        .catch(error => {
          this.$swal.fire("There was a problem","There was an issue retrieving your trip");
        });
    },
    toggleWizardNextPrev: function() {
      if(this.step != 'style' && this.step != 'size' && this.step != 'lookbook' && this.step != 'checkout') {
        this.$store.commit('setWizardNextDisabled', this.nextDisabled);
        this.$store.commit('setWizardPrevDisabled', this.previousDisabled);
      }
      
      let progressDesc = 'trip';
      if(this.step == 'style') progressDesc = 'style';
      if(this.step == 'size') progressDesc = 'size';
      if(this.step == 'lookbook') progressDesc = 'lookbook';
      if(this.step == 'checkout') progressDesc = 'checkout';
      this.$store.commit('setWizardProgressStep', progressDesc);
    },
    toggleValue: function(key, value) {
      let val_index = this.selections[key].indexOf(value);
      
      if(val_index >= 0) {
        this.selections[key].splice(val_index,1);
        return;
      }
      this.selections[key].push(value);
    },

    updateSelections: function(data) {
      if(data.id) this.$set(this.selections, 'id', data.id);
      if(data.review_id) this.$set(this.selections, 'review_id', data.review_id);
      let occasions = [];
      if(data.occasions) {
        for(let i = 0; i < data.occasions.length; i++) {
          occasions.push(data.occasions[i].key);
        }
      }
      this.$set(this.selections, 'occasion_type', occasions);
      this.$set(this.selections, 'location_type', data.location_type);
      this.$set(this.selections.address, 'name', data.reservation_name);
      this.$set(this.selections.address, 'hotel', data.location_name);
      this.$set(this.selections.address, 'street_address', data.location_address);
      this.$set(this.selections.address, 'city', data.location_city);
      this.$set(this.selections.address, 'state', data.location_state);
      this.$set(this.selections.address, 'zip', data.location_zip);
      this.$set(this.selections.address, 'date_start', data.checkin_date);
      this.$set(this.selections.address, 'date_end', data.checkout_date);
      this.$set(this.selections.address, 'travel_city', data.travel_location_city);
      this.$set(this.selections.address, 'travel_state', data.travel_location_state);
      this.$set(this.selections.address, 'travel_country', data.travel_location_country);

      this.$set(this.selections, 'lookbook', data.lookbook);
      this.$set(this.selections, 'order', data.order);
    },
    nextStep: function() {
      this.directionReverse = false;

      if(this.nextDisabled) return;
      if(this.step == 'style') {
        this.$refs.styleWizard.nextStep();
        return;
      }
      if(this.step == 'size') {
        this.$refs.fitWizard.nextStep();
        return;
      }
      if(this.step == 'lookbook') {
        this.$refs.lookbook.nextStep();
        return;
      }


      let update_data = {
        setOccasions: this.selections.occasion_type,
        location_type: this.selections.location_type,
        location_name: this.selections.address.hotel,
        reservation_name: this.selections.address.name,
        location_address: this.selections.address.street_address,
        location_city: this.selections.address.city,
        location_state: this.selections.address.state,
        location_zip: this.selections.address.zip,
        checkin_date: this.selections.address.date_start,
        checkout_date: this.selections.address.date_end
      };
      if(this.selections.location_type == 'ship') {
        update_data.travel_location_city = this.selections.address.travel_city;
        update_data.travel_location_state = this.selections.address.travel_state;
        update_data.travel_location_country = this.selections.address.travel_country;
      }

      if(!this.selections.id && this.step == 'location_details') {
        update_data.user_id = this.user.id;
        this.$http.post('trips?expand=' + this.tripExpansion, update_data)
          .then( response => {
            this.updateSelections(response.data);
          })
          .catch( error => {
            console.log(error);
          });
      } else if(this.selections.id) {
        this.$http.put('trips/' + this.selections.id + '?expand=' + this.tripExpansion, update_data)
          .then( response => {
            this.updateSelections(response.data);
          })
          .catch( error => {
            console.log(error);
          })
      }


      let cur_index = this.wizard.indexOf(this.step);
      this.step = this.wizard[ cur_index + 1 ];
    },
    previousStep: function() {
      this.directionReverse = true;

      if(this.previousDisabled) return;

      if(this.step == 'style') {
        this.$refs.styleWizard.previousStep();
        return;
      }
      if(this.step == 'size') {
        this.$refs.fitWizard.previousStep();
        return;
      }
      if(this.step == 'lookbook') {
        this.$refs.lookbook.previousStep();
        return;
      }
      if(this.step == 'checkout') {
        this.$refs.checkout.previousStep();
        return;
      }


      let cur_index = this.wizard.indexOf(this.step);
      let prev_step = this.wizard[ (cur_index - 1) ];

      /*if(prev_step == 'style') {
        this.step = 'style';
        let ref = this;
        setTimeout(function() {
          ref.$refs.styleWizard.lastStep();
        },1000);
        return;
      }*/

      this.step = this.wizard[ (cur_index - 1) ];
    },

    stylingComplete: function(selections) {
      this.directionReverse = false;
      this.step = 'size';
    },
    stylingCancelled: function() {
      this.directionReverse = true;
      if(!this.styleFirst) this.step = 'location_details';
    },
    sizingComplete: function(selections) {
      this.directionReverse = false;
      
      this.step = (this.styleFirst ? 'activities' : 'lookbook');
    },
    sizingCancelled: function() {
      this.directionReverse = true;
      this.step = 'style';
    },

    
    lookbookComplete: function(lookbook) {
      this.directionReverse = false;

      let orderItems = [];
      for(let lbInv of this.selections.lookbook.lookbookInventory) {
        if(lbInv.variation_sel_id) orderItems.push({inventory_id: lbInv.inventory_id, variation_id: lbInv.variation_sel_id});
      }

      if(!this.selections.order || !this.selections.order.id) {
        let orderParams = {
          tripId: this.selections.id,
          user_id: this.user.id,
          type: 'RENTAL',
          setInventory: orderItems
        }
        this.loading = true;
        this.$http.post('orders?expand=' + this.orderExpansion, orderParams)
          .then(response => {
            this.$set(this.selections, 'order', response.data);
            this.step = 'checkout';
          })
          .catch(error => {
            this.$swal.fire('Order Error', 'There was a problem updating your order. Please try again');
          })
          .finally(() => {
            this.loading = false;
          })
      } else if(this.selections.order.status == 'PENDING') {
        let orderParams = {
          setInventory: orderItems
        }
        this.loading = true;
        this.$http.put('orders/' + this.selections.order.id + '?expand=' + this.orderExpansion, orderParams)
          .then(response => {
            this.$set(this.selections, 'order', response.data);
            this.step = 'checkout';
          })
          .catch(error => {
            this.$swal.fire('Order Error', 'There was a problem updating your order. Please try again');
          })
          .finally(() => {
            this.loading = false;
          })
      } else {
        this.step = 'checkout';
      }
      //this.$http.patch('lookbooks/' + this.selections.lookbook.id, {user_selected: this.selections.lookbook.user_selected});
      //this.step = 'checkout';
    },
    lookbookOrderUpdated: function(data) {
      this.$set(this.selections, 'order', data);
    },
    lookbookCancelled: function() {
      this.directionReverse = true;
      let beforeLookbook = null;
      for(let i = 0; i < this.wizard.length; i++) {
        if(this.wizard[i] == 'lookbook') break;
        beforeLookbook = this.wizard[i];
      }
      this.step = beforeLookbook;
    },
    checkoutCancelled: function() {
      this.directionReverse = true;
      this.step = 'lookbook';
    },

    updateSelectedAddress: function(addr) {
      this.$set(this.selections, 'address', addr);
    },
    updateSelectedStyle: function(style) {
      this.$set(this.selections, 'style', style);
    },
    updateSelectedSize: function(size) {
      this.$set(this.selections, 'size', size);
    },
    updateLookbook: function(lookbook) {
      this.$set(this.selections, 'lookbook', lookbook);
    },
    updateOrder: function(order) {
      this.$set(this.selections, 'order', order);
    }
  }
}
</script>
